<script>
export default {
  name: 'MenuItem',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: () => false
    },
    to: {
      type: Object,
      required: false,
      default: () => ({name: '#'})
    },
    label: {
      type: String,
      required: false,
      default: () => 'menu'
    },
    icon: {
      type: String,
      required: false,
      default: () => ''
    },
    iconColorClass: {
      type: String,
      required: false,
      default: () => 'text-white'
    },
    iconType: {
      type: String,
      required: false,
      default: () => 'fa'
    }
  }
}
</script>

<template>
  <li v-if="show">
    <router-link :to="to">
      <i :class="`${iconType} ${icon} ${iconColorClass} icon`"></i>
      <span>
        <slot>{{ label }}</slot>
      </span>
    </router-link>
  </li>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// MenuItem.vue?de0774fc